module.exports = __webpack_public_path__ + "static/media/icon-pegawai.52b8701b.png";